import * as React from "react";
import { FormItemProps } from "antd/lib/form/FormItem";
import { WrappedFormUtils } from "antd/lib/form/Form";
import Select, { SelectProps } from "antd/lib/select";
import "./PbrSelect.scss";
import { PbrFormItem } from "../PbrFormItem/PbrFormItem";

export interface IPbrSelectProps extends SelectProps {
    error?: boolean;
    rules?: any[];
    formWrapper?: WrappedFormUtils;
    formItemProps?: FormItemProps;
    name: string;
    value: any;
}

export class PbrSelect extends React.Component<IPbrSelectProps> {
    public render() {
        const getFieldDecorator = this.props.formWrapper ? this.props.formWrapper.getFieldDecorator : null;
        const props = { ...this.props };
        const formItemProsp = this.props.formItemProps;
        const value = props.value === null || props.value === undefined ? undefined : props.value;

        delete props.formWrapper;
        delete props.formItemProps;
        delete props.value;

        return (
            <PbrFormItem {...formItemProsp} className="pbr-standard-select">
                {(getFieldDecorator && getFieldDecorator(props.name, { rules: props.rules, initialValue: value })(this.renderSelect(props))) || this.renderSelect(props)}
            </PbrFormItem>
        );
    }

    public renderSelect(props: IPbrSelectProps) {
        return (
            <Select
                {...props}
                optionFilterProp="children"
                placeholder={props.placeholder}
                filterOption={(input, option) => {
                    if (option.props.children) {
                        return (
                            option.props.children
                                .toString()
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        );
                    }
                    return false;
                }}
            >
                {this.props.children}
            </Select>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PbrSelect/PbrSelect.tsx